import { FormError } from 'shared/components/FormControl';

import Button from 'design-system/components/Button';
import Input from 'design-system/components/Input';
import Spacer from 'design-system/components/Spacer';
import { HStack } from 'design-system/components/Stack';
import { Label } from 'design-system/components/Text';
import { useFormSecurely } from 'lib/security/reactHookForm';

interface FormRenameTableViewProps {
  tableViewName: string;
  handleCancel: () => void;
  handleRenameTableView: ({ name }: { name: string }) => void;
}

const FormRenameTableView = ({
  tableViewName,
  handleCancel,
  handleRenameTableView,
}: FormRenameTableViewProps) => {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors, isValid },
  } = useFormSecurely<{ name: string }>({
    defaultValues: { name: tableViewName },
    mode: 'onChange',
  });

  return (
    <form onSubmit={handleSubmit(handleRenameTableView)}>
      <Label id='form-rename-table-view--name'>View name</Label>
      <Input
        aria-labelledby='form-rename-table-view--name'
        {...register('name', { required: true })}
        disabled={isSubmitting}
      />
      {errors['name'] && <FormError>{errors['name'].message}</FormError>}
      <Spacer height={2} />
      <HStack equal={true}>
        <Button
          id='configurable-cases-table__form-rename-table-view--cancel'
          onClick={handleCancel}
          variant='basic'
        >
          Cancel
        </Button>
        <Button
          id='configurable-cases-table__form-rename-table-view--save'
          disabled={isSubmitting || !isValid}
          isPending={isSubmitting}
          type='submit'
        >
          Submit
        </Button>
      </HStack>
    </form>
  );
};

export default FormRenameTableView;
